import React, { useEffect, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import "./PdfViewer.scss"
import fileUtils from '../../fileUtils';

// Configure the worker path for PDF.js
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

interface PDFViewerProps {
    url: string;
    noBorder?: boolean;
    skipLoader?: boolean;
}

const PDFViewer: React.FC<PDFViewerProps> = ({ url, noBorder = false, skipLoader = false }) => {
    const [numPages, setNumPages] = useState<any>(null);
    const [pageNumber, setPageNumber] = useState<any>(1);
    const [fileUrl, setFileUrl] = useState<any>("")
    const [loading, setLoading] = useState<any>(true)

    useEffect(() => {
        // setLoading(true)
        if (url) {
            getUrl()
        }
        else {
            setLoading(false)
        }
    }, [url])

    const getUrl = async () => {
        try {
            const res: any = await fileUtils.getFileUrl(url, skipLoader)
            if (res) {
                setFileUrl(res)
                setLoading(false)
            }
            else {
                setLoading(false)
            }
        }
        catch {
            setLoading(false)
        }
    }

    const onDocumentLoadSuccess = ({ numPages }: any) => {
        setNumPages(numPages);
    };

    return (
        <div>
            <div className="pdf-container">
                <div className={noBorder ? 'pdf-content-no-border' : 'pdf-content'}>
                    {
                        loading ? (
                            <div
                                style={{
                                    position: "absolute",
                                    top: "25%",
                                    right: "50%",
                                }}
                            >
                                <div
                                    style={{ width: "2rem", height: "2rem" }}
                                    className="spinner-border text-primary"
                                ></div>
                            </div>
                        ) : (
                            <Document
                                file={fileUrl ? fileUrl : ""}
                                onLoadSuccess={onDocumentLoadSuccess}
                                loading={
                                    <div>
                                        <div
                                            style={{ width: "2rem", height: "2rem" }}
                                            className="spinner-border text-primary"
                                        ></div>
                                    </div>
                                }
                            >
                                {Array.from(new Array(numPages), (el, index) => (
                                    <Page
                                        key={`page_${index + 1}`}
                                        pageNumber={index + 1}
                                        scale={4}
                                        loading={""}
                                    />
                                ))}
                            </Document>
                        )
                    }
                </div>
            </div>
        </div>
    );
};

export default PDFViewer